module.exports = __webpack_public_path__ + "static/media/18.cb928f04.png";